/*
* @Author: jack
* @Date:   2022-08-09 15:13:54
* @Last Modified by:   jack
* @Last Modified time: 2022-08-10 21:07:06
*/
import request from '@/utils/request'


export function getIndex(data) {
  return request({
    url: 'acitvity/vote/index',
    method: 'post',
    data
  })
}
export function addVote(data) {
  return request({
    url: 'acitvity/vote/addVote',
    method: 'post',
    data
  })
}
export function getVote(data) {
  return request({
    url: 'acitvity/vote/getVote',
    method: 'post',
    data
  })
}

export function getRank(data) {
  return request({
    url: 'acitvity/vote/getRank',
    method: 'post',
    data
  })
}
export function getVoteCode(data) {
  return request({
    url: 'acitvity/vote/getVoteCode',
    method: 'post',
    data
  })
}
export function gongweiChoujiang(data) {
  return request({
    url: 'acitvity/vote/gongweiChoujiang',
    method: 'post',
    data
  })
}
export function lingqu(data) {
  return request({
    url: 'acitvity/dati/question/callback',
    method: 'post',
    data
  })
}
export function addNumber(data) {
  return request({
    url: 'acitvity/vote/addNumber',
    method: 'post',
    data
  })
}


